import { render, staticRenderFns } from "./de-tdb.vue?vue&type=template&id=62a8df6e&"
import script from "./de-tdb.vue?vue&type=script&lang=js&"
export * from "./de-tdb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62a8df6e')) {
      api.createRecord('62a8df6e', component.options)
    } else {
      api.reload('62a8df6e', component.options)
    }
    module.hot.accept("./de-tdb.vue?vue&type=template&id=62a8df6e&", function () {
      api.rerender('62a8df6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion-2023/de-tdb.vue"
export default component.exports